<template>
  <div class="account-page">
    <div class="account-container">
      <!-- 左侧导航 -->
      <div class="account-sidebar">
        <div class="user-info">
          <div class="user-avatar-large">
            <span>{{ userInitials }}</span>
          </div>
          <h3 class="user-name">{{ userName }}</h3>
          <p class="user-email">{{ userEmail }}</p>
        </div>
        
        <nav class="sidebar-nav">
          <a href="javascript:void(0)" 
             :class="['nav-item', { active: activeTab === 'profile' }]"
             @click="activeTab = 'profile'">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
            <span>Profile</span>
          </a>
          
          <!-- <a href="javascript:void(0)" 
             :class="['nav-item', { active: activeTab === 'orders' }]"
             @click="activeTab = 'orders'">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <path d="M16 10a4 4 0 0 1-8 0"></path>
            </svg>
            <span>购买</span>
          </a> -->
          
          <!-- <a href="javascript:void(0)" 
             :class="['nav-item', { active: activeTab === 'favorites' }]"
             @click="activeTab = 'favorites'">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
            </svg>
            <span>收藏</span>
          </a> -->
          
          <!-- <a href="javascript:void(0)" 
             :class="['nav-item', { active: activeTab === 'settings' }]"
             @click="activeTab = 'settings'">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path>
              <circle cx="12" cy="12" r="3"></circle>
            </svg>
            <span>设置</span>
          </a> -->
          
          <a href="javascript:void(0)" 
             :class="['nav-item', { active: activeTab === 'logout' }]"
             @click="handleLogout">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
            <span>Log Out</span>
          </a>
        </nav>
      </div>
      
      <!-- 右侧内容区 -->
      <div class="account-content">
        <!-- 加载状态 -->
        <div v-if="loading" class="loading-state">
          <div class="loading-spinner"></div>
          <p>Loading...</p>
        </div>
        
        <!-- Profile Tab -->
        <div v-else-if="activeTab === 'profile'" class="content-section">
          <div class="form-section">
            <h3 class="section-title">Personal Information</h3>
            
            <div class="form-row">
              <div class="form-group">
                <label>First Name</label>
                <input type="text" v-model="settings.firstName" class="form-control" placeholder="Enter first name">
              </div>
              <div class="form-group">
                <label>Last Name</label>
                <input type="text" v-model="settings.lastName" class="form-control" placeholder="Enter last name">
              </div>
            </div>
            
            <div class="form-row">
              <div class="form-group">
                <label>Phone</label>
                <input type="text" v-model="settings.phone" class="form-control" placeholder="Enter phone number">
              </div>
              <div class="form-group">
                <label>Email</label>
                <input type="email" v-model="settings.email" class="form-control" placeholder="Email address" disabled>
                <small style="color: #999; font-size: 12px; margin-top: 5px; display: block;">Email cannot be changed</small>
              </div>
            </div>
            
            <button class="btn-save" @click="saveUserInfo">Save</button>
          </div>
        </div>
        
        <!-- Settings Tab -->
        <div v-else-if="activeTab === 'settings'" class="content-section">
          <div class="empty-state">
            <p>Settings coming soon...</p>
          </div>
        </div>
        
        <!-- 其他Tab内容 -->
        <div v-else class="content-section">
          <div class="empty-state">
            <p>{{ activeTab }} coming soon...</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import userStore from '../store/user.js'
import { userApi } from '@/api'

export default {
  name: 'Account',
  data() {
    return {
      userStore: userStore.state,
      activeTab: 'profile',
      loading: false,
      settings: {
        firstName: '',
        lastName: '',
        phone: '',
        email: ''
      }
    }
  },
  computed: {
    userName() {
      // 优先使用 settings 中的数据（从接口加载的最新数据）
      if (this.settings.firstName && this.settings.lastName) {
        return `${this.settings.firstName} ${this.settings.lastName}`
      }
      // 其次使用 userStore 中的数据
      if (this.userStore.user?.firstname && this.userStore.user?.lastname) {
        return `${this.userStore.user.firstname} ${this.userStore.user.lastname}`
      }
      // 最后使用默认值
      return this.userStore.user?.name || 'User'
    },
    userEmail() {
      // 优先使用 settings 中的数据
      return this.settings.email || this.userStore.user?.email || ''
    },
    userInitials() {
      const name = this.userName
      const parts = name.split(' ')
      if (parts.length >= 2) {
        return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase()
      }
      return name.substring(0, 2).toUpperCase()
    }
  },
  async mounted() {
    // 检查登录状态
    userStore.checkAuth()
    
    // 如果未登录，跳转到首页
    if (!this.userStore.isLoggedIn) {
      this.$router.push('/').catch(() => {})
      return
    }
    
    // 加载用户信息
    await this.loadUserInfo()
  },
  methods: {
    async loadUserInfo() {
      try {
        this.loading = true
        const response = await userApi.getUserInfo()
        
        console.log('=== 用户信息接口响应 ===')
        console.log('完整响应:', JSON.stringify(response, null, 2))
        
        if (response.code === 1 && response.data) {
          const userData = response.data
          console.log('用户数据:', userData)
          
          // 更新 userStore
          userStore.updateUserInfo(userData)
          
          // 更新 settings - 使用接口返回的字段
          this.settings.firstName = userData.firstname || ''
          this.settings.lastName = userData.lastname || ''
          this.settings.email = userData.email || ''
          this.settings.phone = userData.phone || ''
          
          console.log('Settings 更新后:', {
            firstName: this.settings.firstName,
            lastName: this.settings.lastName,
            email: this.settings.email,
            phone: this.settings.phone
          })
          
          console.log('✅ 用户信息加载成功')
        } else {
          console.error('❌ 用户信息加载失败:', response.msg || '未知错误')
          this.$toast('Failed to load user info: ' + (response.msg || 'Unknown error'), 3000)
        }
      } catch (error) {
        console.error('❌ 加载用户信息异常:', error)
        console.error('错误详情:', error.response)
        
        // 如果是 401 错误，token 可能过期
        if (error.response && error.response.status === 401) {
          this.$toast('Session expired, please log in again', 3000)
          userStore.logout()
          this.$router.push('/').catch(() => {})
        } else {
          this.$toast('Failed to load user info, please refresh the page', 3000)
        }
      } finally {
        this.loading = false
      }
    },
    async handleLogout() {
      // 确认提现
      const confirmed = await this.$confirm('Are you sure you want to log out?')
      if (!confirmed) {
        return
      }
      userStore.logout()
      this.$router.push('/').catch(() => {})
    },
    async saveUserInfo() {
      // 验证必填字段
      if (!this.settings.firstName || !this.settings.lastName || !this.settings.phone) {
        this.$toast('Please fill in your full name and phone number')
        return
      }
      
      try {
        const response = await userApi.editInfo({
          firstname: this.settings.firstName,
          lastname: this.settings.lastName,
          phone: this.settings.phone
        })
        
        if (response.code === 1) {
          this.$toast('Saved successfully!')
          // 重新加载用户信息
          await this.loadUserInfo()
        } else {
          this.$toast(response.msg || 'Save failed', 3000)
        }
      } catch (error) {
        console.error('Failed to save user info:', error)
        this.$toast('Save failed, please try again', 3000)
      }
    }
  }
}
</script>

<style scoped>
.account-page {
  min-height: 100vh;
  /* background: #f5f5f5; */
  padding-top: 80px;
}

.account-container {
  max-width: 1600px !important;
  margin: 0 auto;
  display: flex;
  gap: 30px;
  padding: 30px 20px;
  align-items: flex-start;
}

/* 左侧导航栏 */
.account-sidebar {
  width: 280px;
  flex-shrink: 0;
}

.user-info {
  background: white;
  border-radius: 8px;
  padding: 30px 20px;
  text-align: center;
  margin-bottom: 20px;
}

.user-avatar-large {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: #ff0000;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 40px;
  font-weight: bold;
  margin: 0 auto 15px;
}

.user-name {
  margin: 0 0 5px 0;
  font-size: 20px;
  font-weight: 500;
}

.user-email {
  margin: 0;
  color: #666;
  font-size: 14px;
}

.sidebar-nav {
  background: white;
  border-radius: 8px;
  overflow: hidden;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  color: #333;
  text-decoration: none;
  border-bottom: 1px solid #f0f0f0;
  transition: all 0.3s;
  cursor: pointer;
}

.nav-item:last-child {
  border-bottom: none;
}

.nav-item:hover {
  background: #f9f9f9;
}

.nav-item.active {
  background: #fff8e1;
  color: #000;
  border-bottom: 2px solid #ffc200;
}

.nav-item svg {
  flex-shrink: 0;
}

.nav-item span {
  font-size: 15px;
}

/* 右侧内容区 */
.account-content {
  flex: 1;
  background: white;
  border-radius: 8px;
  padding: 40px;
  /* overflow-y: auto; */
  /* max-height: calc(100vh - 160px); */
}

.content-section {
  max-width: 100%;
  width: 100%;
}

.form-section {
  margin-bottom: 40px;
  padding-bottom: 40px;
  border-bottom: 1px solid #e0e0e0;
  overflow: visible;
}

.form-section:last-child {
  border-bottom: none;
}

.section-title {
  font-size: 18px;
  font-weight: 500;
  margin: 0 0 20px 0;
  color: #333;
}

.form-row {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  overflow: visible;
}

.form-group {
  flex: 1;
  overflow: visible;
  position: relative;
}

.form-group label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #333;
}

.form-control {
  width: 100%;
  /* padding: 12px 16px; */
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  transition: border-color 0.3s;
  box-sizing: border-box;
  background: white;
  color: #333;
  line-height: 1.5;
}

.form-control:focus {
  outline: none;
  border-color: #ffc200;
}

select.form-control {
  appearance: auto;
  -webkit-appearance: menulist;
  -moz-appearance: menulist;
  cursor: pointer;
  padding-right: 30px;
}

.btn-save {
  padding: 10px 30px;
  background: #666;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s;
  margin-top: 10px;
}

.btn-save:hover {
  background: #555;
}

/* 兴趣爱好网格 */
.interests-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px 20px;
  margin-bottom: 20px;
}

.interest-item {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  user-select: none;
  padding: 5px 0;
}

.interest-item input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  border-radius: 50%;
  border: 2px solid #ddd;
  appearance: none;
  -webkit-appearance: none;
  position: relative;
  flex-shrink: 0;
  margin: 0;
}

.interest-item input[type="checkbox"]:checked {
  background: #000;
  border-color: #000;
}

.interest-item input[type="checkbox"]:checked::after {
  content: '';
  position: absolute;
  left: 5px;
  top: 1px;
  width: 4px;
  height: 9px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.interest-label {
  font-size: 14px;
  color: #666;
  line-height: 1.4;
}

.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #999;
}

/* 加载状态 */
.loading-state {
  text-align: center;
  padding: 80px 20px;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #ffc200;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-state p {
  color: #666;
  font-size: 16px;
  margin: 0;
}

/* 通知设置 */
.notification-setting {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid #f0f0f0;
}

.notification-setting:last-of-type {
  border-bottom: none;
  margin-bottom: 20px;
}

.notification-text {
  flex: 1;
}

.notification-title {
  margin: 0 0 5px 0;
  font-size: 14px;
  color: #333;
  font-weight: 400;
}

.notification-desc {
  margin: 0;
  font-size: 13px;
  color: #999;
}

.notification-options {
  display: flex;
  gap: 20px;
  align-items: center;
}

.radio-option {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
}

.radio-option input[type="radio"] {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin: 0;
}

.radio-option span {
  font-size: 14px;
  color: #333;
}

.btn-save-dark {
  padding: 10px 30px;
  background: #000;
  color: white;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s;
  margin-top: 10px;
}

.btn-save-dark:hover {
  background: #333;
}

.btn-save-light {
  padding: 10px 30px;
  background: #e0e0e0;
  color: #333;
  border: none;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.3s;
  margin-top: 10px;
}

.btn-save-light:hover {
  background: #d0d0d0;
}

/* 移动端适配 */
@media (max-width: 767px) {
  .account-page {
    padding-top: 60px;
  }
  
  .account-container {
    flex-direction: column;
    padding: 15px 15px 80px;
    gap: 15px;
  }
  
  .account-sidebar {
    width: 100%;
  }
  
  .user-info {
    padding: 20px 15px;
  }
  
  .user-avatar-large {
    width: 70px;
    height: 70px;
    font-size: 28px;
  }
  
  .user-name {
    font-size: 18px;
  }
  
  .user-email {
    font-size: 13px;
  }
  
  .nav-item {
    padding: 14px 15px;
  }
  
  .nav-item svg {
    width: 16px;
    height: 16px;
  }
  
  .nav-item span {
    font-size: 14px;
  }
  
  .account-content {
    padding: 20px 15px;
    max-height: none;
    width: 100%;
  }
  
  .form-section {
    margin-bottom: 30px;
    padding-bottom: 30px;
  }
  
  .section-title {
    font-size: 16px;
    margin-bottom: 15px;
  }
  
  .form-row {
    flex-direction: column;
    gap: 15px;
    margin-bottom: 15px;
  }
  
  .form-group label {
    font-size: 13px;
    margin-bottom: 6px;
  }
  
  .form-control {
    font-size: 14px;
    padding: 10px 12px;
  }
  
  .btn-save,
  .btn-save-dark,
  .btn-save-light {
    width: 100%;
    padding: 12px 20px;
    font-size: 14px;
  }
  
  .interests-grid {
    grid-template-columns: 1fr;
    gap: 10px;
  }
  
  .interest-item {
    padding: 8px 0;
  }
  
  .interest-label {
    font-size: 13px;
  }
  
  /* 通知设置移动端优化 */
  .notification-setting {
    flex-direction: column;
    align-items: flex-start;
    padding: 15px 0;
    gap: 12px;
  }
  
  .notification-text {
    width: 100%;
  }
  
  .notification-title {
    font-size: 13px;
    line-height: 1.5;
  }
  
  .notification-desc {
    font-size: 12px;
  }
  
  .notification-options {
    width: 100%;
    justify-content: flex-start;
    gap: 30px;
  }
  
  .radio-option {
    gap: 6px;
  }
  
  .radio-option input[type="radio"] {
    width: 18px;
    height: 18px;
  }
  
  .radio-option span {
    font-size: 13px;
  }
}
</style>
